import { useAuthQuery } from 'lib/hooks/use-query.js';
import { fetchAndParse } from 'lib/helpers/fetch.js';

export function useGetTransferTypes() {
    const { data, ...queryProps } = useAuthQuery({
        queryKey: ['transfertypes'],
        staleTime: 'Infinity',
        refetchOnWindowFocus: false,
        retry: false,
        retryOnMount: false,
        queryFn: (_, headers) =>
            fetchAndParse(`${API_URL}/p/transfertypes`, {
                headers
            })
    });

    return { transferTypes: data?.transferTypes || [], ...queryProps };
}
